<template>
<div class="chapter">
<div class="inner_page">
<p class="prect"><a id="pV"></a>Contents</p>
<p class="contents-1"><a href="#/list_of_maps.htm"><i>List of Maps</i></a></p>
<p class="contents-1"><a href="#/acknowledgements.htm"><i>Acknowledgements</i></a></p>
<p class="contents-1"><a href="#/introduction.htm"><i>Introduction</i></a></p>
<p class="linespace"></p>
<p class="contents"><a href="#/ch1.htm"><span class="contentblock">1</span> The Origins of the Naval Offensive</a></p>
<p class="contents"><a href="#/ch2.htm"><span class="contentblock">2</span> From Ships to Troops</a></p>
<p class="contents"><a href="#/ch3.htm"><span class="contentblock">3</span> The Worst-Laid Plans</a></p>
<p class="contents"><a href="#/ch4.htm"><span class="contentblock">4</span> The Rise and Fall of the Naval Attack</a></p>
<p class="contents"><a href="#/ch5.htm"><span class="contentblock">5</span> No Going Back</a></p>
<p class="contents"><a href="#/ch6.htm"><span class="contentblock">6</span> The Military Plan</a></p>
<p class="contents"><a href="#/ch7.htm"><span class="contentblock">7</span> Bodies Everywhere: The Helles Landings</a></p>
<p class="contents"><a href="#/ch8.htm"><span class="contentblock">8</span> A Perfect Hail of Bullets: Landing and Consolidation at Anzac</a></p>
<p class="contents"><a href="#/ch9.htm"><span class="contentblock">9</span> The Killing Fields of Krithia</a></p>
<p class="contents"><a href="#/ch10.htm"><span class="contentblock">10</span> Last Throw in the South</a></p>
<p class="contents"><a href="#/ch11.htm"><span class="contentblock">11</span> The Plans of August</a></p>
<p class="contents"><a href="#/ch12.htm"><span class="contentblock">12</span> The Assault on Sari Bair</a></p>
<p class="contents"><a href="#/ch13.htm"><span class="contentblock">13</span> Suvla Bay: The Scapegoat Battle</a></p>
<p class="contents"><a href="#/ch14.htm"><span class="contentblock">14</span> ‘War as we must’: The Political Debate</a></p>
<p class="contents"><a href="#/ch15.htm"><span class="contentblock">15</span> A Campaign Not Won</a></p>
<p class="contents-1"><a href="#/reflections_on_gallipoli.htm">Reflections on Gallipoli</a></p>
<p class="linespace"></p>
<p class="contents-1"><a href="#/notes.htm"><i>Notes</i></a></p>
<p class="contents-1"><a href="#/bibliography.htm"><i>Bibliography</i></a></p>
<p class="contents-1"><a href="#/index.htm"><i>Index</i></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6c0a978c